import React, { useEffect, useState } from "react";
import CgFormCreator from "../../common/CgFormCreator";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyaccountLogin, updateLoginInformation, fetchUpdateToken } from "../../store/Myaccount/myaccountActions";
import { resetUpdateStatus } from "../../store/Myaccount/myaccountReducers";

const LoginInformation = () => {
  const dispatch = useDispatch();
  const { myaccountLogin, isLoading, updateSuccess, error } = useSelector(
    (state) => state.myaccountLoginInformation
  );
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [formValid, setFormValid] = useState(true);

  useEffect(() => {
    dispatch(fetchMyaccountLogin());
    return () => {
      dispatch(resetUpdateStatus());
    };
  }, [dispatch]);

  useEffect(() => {
    if (updateSuccess && formSubmitted) {
      const timer = setTimeout(() => {
        dispatch(resetUpdateStatus());
        setFormSubmitted(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [updateSuccess, formSubmitted, dispatch]);

  const [formKey, setFormKey] = useState('initial-form');
  
  useEffect(() => {
    if (myaccountLogin?.user) {
      setFormKey(`login-form-${myaccountLogin.user.username || ''}`);
    }
  }, [myaccountLogin?.user?.username, myaccountLogin?.user?.firstName, myaccountLogin?.user?.lastName]);

  const [formFields, setFormFields] = useState({
    firstName: myaccountLogin?.user?.firstName || '',
    lastName: myaccountLogin?.user?.lastName || '',
    username: myaccountLogin?.user?.username || ''
  });
  
  useEffect(() => {
    if (myaccountLogin?.user) {
      const username = myaccountLogin.user.username || '';
      setFormFields({
        firstName: myaccountLogin.user.firstName || '',
        lastName: myaccountLogin.user.lastName || '',
        username: username
      });
      validateEmail(username);
    }
  }, [myaccountLogin?.user]);
  
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || email.trim() === '') {
      setEmailError("Please enter a valid email address");
      setFormValid(false);
      return false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      setFormValid(false);
      return false;
    } else {
      setEmailError("");
      setFormValid(true);
      return true;
    }
  };
  
  const handleInputChange = (name, value) => {
    setFormFields(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (name === 'username') {
      validateEmail(value);
    }
  };
  
  const LoginInformationSchema = [
    {
      component: "input",
      label: "FIRST NAME",
      type: "text",
      name: "firstName",
      defaultValue: formFields.firstName,
      valueChangeCallback: handleInputChange,
      onKeyChangeCallback: handleInputChange,
    },
    {
      component: "input",
      label: "LAST NAME",
      type: "text",
      name: "lastName",
      defaultValue: formFields.lastName,
      valueChangeCallback: handleInputChange,
      onKeyChangeCallback: handleInputChange,
    },
    {
      component: "input",
      label: "EMAIL",
      type: "email",
      name: "username",
      placeholder: " ",
      defaultValue: formFields.username,
      valueChangeCallback: handleInputChange,
      onKeyChangeCallback: handleInputChange,
    },
  ];

  const RenderLoginInformationFormCreator = () => {
    if (isLoading) return <div> Loading ... </div>;
    return (
      <div className="login-information-form">
        {error && formSubmitted && (
          <div className="error-message">Failed to update login information. Please try again.</div>
        )}
        {emailError && (
          <div className="error-message" style={{ color: 'red' }}>{emailError}</div>
        )}
        <CgFormCreator
          schema={LoginInformationSchema}
          primaryButton="Save"
          enablePrimaryBtn={formValid}
          onSubmitCallback={(value) => {
            if (!validateEmail(value?.username)) {
              return;
            }
            
            setFormSubmitted(true);
            
            const updateLoginPayload = {
              originalUserName: myaccountLogin?.user?.username,
              updatedUserName: value?.username,
              firstName: value?.firstName,
              lastName: value?.lastName
            };
            
            const updateTokenPayload = {
              username: value?.username,
              firstName: value?.firstName,
              lastName: value?.lastName
            };
            dispatch(updateLoginInformation(updateLoginPayload))
              .then(() => dispatch(fetchUpdateToken(updateTokenPayload)))
              .then(() => dispatch(fetchMyaccountLogin()));
          }}
          noCancel
        />
      </div>
    );
  };

  return (
    <div className="login-information">
      <h2 className="info-section-header text-uppercase">Login Information</h2>
      <div className="login-section-content">
        {RenderLoginInformationFormCreator()}
      </div>
    </div>
  );
};
export default LoginInformation;